// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"401a5b83","488":"8f00bd44","541":"36a9eff5","638":"651d4dbe","720":"d050817b","848":"d76bd38f"}[chunkId] + ".chunk.js";
};